import MainApp from './MainApp';
import IframeApp from './IframeApp';
import { StateProvider } from './pages/scan-and-register/stateContext';
import { preloadNewMenuTutorialImages } from './services/newMenuTutorial/preloadImages';

const isIframe = window.location.href.toLocaleLowerCase().includes('/iframe');

preloadNewMenuTutorialImages();

function App(props: any) {
  return (
    <>
      {isIframe ? (
        <IframeApp />
      ) : (
        <StateProvider>
          <MainApp />
        </StateProvider>
      )}
    </>
  );
}
export default App;
